"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcModal = void 0;
var react_1 = require("react");
var useAcModal = function () {
    /**
     * useRef is required as showing and hiding multiple modals may happen in the same React cycle.
     */
    var openedModalIds = react_1.useRef([]);
    var savedPosition = react_1.useRef(null);
    var scrollTimer = react_1.useRef(null);
    var scrollToSavedPosition = function () {
        // Set timeout to wait for all the state to fully re-render (if any)
        // without timer, re-render will cause the scroll to be top back after scrollTop-ed
        if (savedPosition.current) {
            scrollTimer.current = setTimeout(function () {
                var _a;
                window.scrollTo(0, (_a = savedPosition.current) !== null && _a !== void 0 ? _a : 0);
                savedPosition.current = null; // reset position
                if (scrollTimer.current) {
                    clearTimeout(scrollTimer.current);
                }
                scrollTimer.current = null;
            }, 500);
        }
    };
    var onShowModal = react_1.useCallback(function (modalId) {
        if (openedModalIds.current.length === 0) {
            if (scrollTimer.current) {
                // Sometimes after a modal has been closed, a new modal is immediately opened.
                // In this case, the scrollTimer should be still active
                // and the current saved position must be preserved
                // as window.pageYOffset will return zero as the hook has no chance to scroll the window yet.
                clearTimeout(scrollTimer.current);
                scrollTimer.current = null;
            }
            else {
                savedPosition.current = window.pageYOffset;
            }
        }
        var modalIdSet = new Set(openedModalIds.current);
        if (!modalIdSet.has(modalId)) {
            modalIdSet.add(modalId);
            var updatedOpenedModalIds = __spreadArray([], __read(modalIdSet));
            openedModalIds.current = updatedOpenedModalIds;
        }
    }, []);
    var onHideModal = react_1.useCallback(function (modalId) {
        var modalIdSet = new Set(openedModalIds.current);
        if (modalIdSet.has(modalId)) {
            modalIdSet.delete(modalId);
            var updatedOpenedModalIds = __spreadArray([], __read(modalIdSet));
            if (updatedOpenedModalIds.length === 0 && savedPosition.current && !scrollTimer.current) {
                scrollToSavedPosition();
            }
            openedModalIds.current = updatedOpenedModalIds;
        }
    }, []);
    var hasOpenedModal = react_1.useMemo(function () {
        var _a;
        return ((_a = openedModalIds.current) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }, [openedModalIds]);
    return {
        openedModalIds: openedModalIds.current,
        hasOpenedModal: hasOpenedModal,
        onShowModal: onShowModal,
        onHideModal: onHideModal,
    };
};
exports.useAcModal = useAcModal;
//# sourceMappingURL=UseAcModal.js.map